import { Component, OnInit, ViewEncapsulation, OnDestroy, Inject } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ToastController, LoadingController } from '@ionic/angular';
import { AppRouterService } from '../core/services/app-router.service';
import { BackendService } from '../core/services/backend-prod.service';
import { Storage } from '@ionic/storage';
import { HelperService } from '../core/services/helper.service';
import { NavigationStart, Router } from '@angular/router';
import { publicIpv4 } from 'public-ip';
import { filter, map, takeUntil } from 'rxjs/operators';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType, InteractionType, AccountInfo, SsoSilentRequest} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { PublicClientApplication,IPublicClientApplication } from '@azure/msal-browser';
import { resolve } from 'dns';
import { rejects } from 'assert';
import { error } from 'console';
import { HttpClient } from '@angular/common/http';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

@Component({
  selector: 'app-start-free-trial',
  templateUrl: './start-free-trial.page.html',
  styleUrls: ['./start-free-trial.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StartFreeTrialPage implements OnInit, OnDestroy {
  private countriesApi: any;
  private registerApi: any;
  showempcom: boolean = true;
  isMSAL: boolean = false;
  userIp: any;

  constructor(
    private title: Title,
    private fb: UntypedFormBuilder,
    public toastController: ToastController,
    private backendService: BackendService,
    private appRouter: AppRouterService,
    public loadingController: LoadingController,
    public storage: Storage,
    public router: Router,
    public helperService: HelperService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private http: HttpClient
  ) { }

  jobTitle;
  employee;
  countries;
  signupform: UntypedFormGroup;
  submitted: boolean = false;
  submitdone: boolean = false;

  loginDisplay = false;
  isIframe = false;s
  private readonly _destroying$ = new Subject<void>();

  ngOnInit() {
    this.title.setTitle('eZintegrations | Start Free Trial ');
    this.jobTitle = this.helperService.jobTitle;
    this.employee = this.helperService.employee;
    this.getcountries();

    this.signupform = this.fb.group({
      'firstName': ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\s]+([a-zA-Z0-9 ]+)*$')]],
      'lastName': ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\s]+([a-zA-Z0-9 ]+)*$')]],
      'email': ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      'phone': ['', [Validators.required,this.stripSpacesValidator()]],
      'jobTitle': ['', Validators.required],
      'employee': ['', Validators.required],
      'company':['',[Validators.required]],
      'country': ['', Validators.required],
      'agreeSubscription': [false, Validators.requiredTrue],
    });

    this.signupform.get('jobTitle').valueChanges.subscribe(val => {
      if (val.id == "6" || val.id == "7") {
        this.signupform.controls['employee'].clearValidators();
        this.signupform.controls['company'].clearValidators();
        this.showempcom = false;
      } else {
        this.signupform.controls['employee'].setValidators([Validators.required]);
        this.signupform.controls['company'].setValidators([Validators.required]);
        this.showempcom = true;
      }
      this.signupform.controls['employee'].updateValueAndValidity();
      this.signupform.controls['company'].updateValueAndValidity();
    })
    this.getUserIp();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
       this.helperService.dismissToast();
      }
    });

    this.isIframe = window !== window.parent && !window.opener;
    // this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    // this.setLoginDisplay();
    
    // this.msalBroadcastService.inProgress$
    //   .pipe(
    //     filter((status: InteractionStatus) => status === InteractionStatus.None),
    //     takeUntil(this._destroying$)
    //   )
    //   .subscribe(() => {
    //     this.setLoginDisplay();
    //     this.checkAndSetActiveAccount();
    //   })
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    //console.log("setLoginDisplay",this.loginDisplay)
    this.checkAndSetActiveAccount();
  }
  
  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    //console.log("checkAndSetActiveAccount",activeAccount)
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      //console.log("checkAndSetActiveAccount",accounts)
    }
  }

  // loginRedirect() {
  //   if (this.msalGuardConfig.authRequest){
  //     this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
  //   } else {
  //     this.authService.loginRedirect();
  //   }
  // }

  async isLogout(){
    return new Promise((resolve)=>{
      const currentUser = this.authService.instance.getAllAccounts()
      const userInfo:any = this.authService.instance.getAllAccounts()
      //console.log("isLogout - ",currentUser)
      const SsoSilentRequest = {
        loginHint: userInfo.user // I have added my static mail id which i used to login in application1
      }

      //===========================
      // //console.log("currentUser",currentUser)
      // const currentAccount = this.authService.instance.getAccountByHomeId(currentUser[0].homeAccountId);
      // Extract login hint to use as logout hint
      // const logoutHint = currentAccount.idTokenClaims.login_hint;
      // this.authService.instance.logoutPopup({ logoutHint: logoutHint });
      //===========================

      this.authService.instance.ssoSilent(SsoSilentRequest).then((res:any) => {
        // Automatically on page load
        this.authService.instance.logoutRedirect({
          onRedirectNavigate: () => {
            // const currentAccount = this.authService.instance.getAccountByHomeId(res.account.homeAccountId)
            const logoutHint = res.account.idTokenClaims.login_hint;
            this.authService.instance.logoutPopup({ logoutHint: logoutHint });
            // this.authService.instance.setActiveAccount(null);
            resolve(true)
            // Return false to stop navigation after local logout
            return false;
          }
        });
        //console.log("SsoSilentRequestLogout - ",res)
      }).catch(error => {
        console.error("Silent Error: " + error);
      });
    })
  }

  checkMSALLogedIn(){
    //console.log("Check active account - ",this.authService.instance.getAllAccounts())
    const activeAccount = this.authService.instance.getAllAccounts()
    if(activeAccount.length > 0){
      this.isLogout().then((data)=>{
        if(data){
          //console.log("loged out - ",this.authService.instance.getAllAccounts())
          setTimeout(()=>{this.loginPopup()},1000)
          // this.loginPopup()
        }
      })
    } else {
      //console.log("NewloginPopup")
      this.loginPopup()
      }
  }

  getProfile() {
    //Fetching basic profile information of usre miscrosoft a/c 
    return new Promise((resolve)=>{
      this.http.get("https://graph.microsoft.com/v1.0/me")
      .subscribe(profile => {
        resolve(profile)
      });
    })
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
          this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
            .subscribe((response: AuthenticationResult) => {
              // this.authService.instance.setActiveAccount(response.account);
              //console.log("LoginResponse - ",response.account)
              this.helperService.loader();
              this.getProfile().then((profileInfo:any)=>{
                //console.log("MS Userinfo - ",profileInfo)
                let first_name = profileInfo.givenName,last_name = profileInfo.surname;
                let payload = {
                  firstName: profileInfo.givenName ? first_name : "",
                  lastName: profileInfo.surname ? last_name : "",
                  email: profileInfo.mail,
                  phone: profileInfo.mobilePhone ? profileInfo.mobilePhone : "",
                  jobTitle: {"id": "7","name": "Others"},
                  employee: "",
                  company: "",
                  country: "",
                  is_sso: true,
                  sso_type: 'microsoft',
                  freeTrialMode: true,
                  create_ip_address: this.userIp
                }
                this.registerApi = this.backendService.Post('register', payload)
                  .subscribe(
                    data => {
                      // this.helperService.closeLoader();
                      this.helperService.closeLoader().then(() => {
                        if (data && data.token) {
                          //console.log("data && data.token")
                          this.setStorageData(data).then(() => {
                            this.helperService.presentAlert('Successful sign-in!', 'Check your email to verify your account.');
                            this.appRouter.gotoPath('baseapp/integration/create');
                          });
                        }
                        else {
                          this.helperService.presentToast('Something went wrong please try again later.', 2000);
                        }
                      });
                    },
                    err => {
                        this.helperService.closeLoader()
                        if(err.error.isTrusted){
                          this.helperService.presentToastWithButton("Try again"); 
                        }else{
                          this.helperService.presentToastWithButton(err.error.detail); 
                        }
                    }
                  );
              })   
            });
    } else {
      this.authService.loginPopup().subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
      });
    }
  }

  getcountries() {
    // this.helperService.loader();
    this.countriesApi = this.backendService.Get('getAllCountries').subscribe(
      (data) => {
        this.countries = data;
        // this.helperService.closeLoader();
      },
      err => {
        // this.helperService.closeLoader();
        if(err.error.isTrusted){
          this.helperService.presentToastWithButton("Unable to fetch country list"); 
        }else{
          this.helperService.presentToastWithButton(err.error.detail); 
        }
        // this.helperService.presentToast("Oops! something went wrong", 2000);
      }
    );
  }

  get f() { return this.signupform.controls; }

  getUserIp(){
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        this.userIp = e.ip;
    })
  }

  async onSubmit() {
    this.submitted = true;
    this.submitdone = true;
    if (this.signupform.invalid) {
      return;
    }
    let payload = {
      firstName: this.signupform.value.firstName.trim(),
      lastName: this.signupform.value.lastName.trim(),
      email: this.signupform.value.email.trim(),
      phone: this.signupform.value.phone.trim(),
      jobTitle: this.signupform.value.jobTitle,
      employee: this.signupform.value.employee,
      company: this.signupform.value.company,
      country: this.signupform.value.country,
      freeTrialMode: true,
      create_ip_address: this.userIp,
      is_sso: false,
      sso_type: '',
    }
    await this.helperService.loader();
    this.registerApi = this.backendService.Post('register', payload)
      .subscribe(
        data => {
          this.submitted = false;
          // this.signupform.reset();
          this.helperService.closeLoader().then(() => {
            if (data && data.token) {
              // this.sessionService.storeUserDetails(data, false, true);
              this.setStorageData(data).then(() => {
                this.helperService.presentAlert('Verify Account!', 'Check your email to verify your account. You can login back only once you confirm your email');
                this.appRouter.gotoPath('baseapp/integration/create');
              });
            }
            else {
              this.helperService.presentToast('Something went wrong please try again later.', 2000);
            }
          });
        },
        err => {
          this.helperService.closeLoader()
          if(err.error.isTrusted){
            this.helperService.presentToastWithButton("Try again"); 
          }else{
            this.helperService.presentToastWithButton(err.error.detail); 
          }
        }
      );
  }

  async setStorageData(data) {
    await this.storage.set('token', data.token);
    await this.storage.set('id', data.id);
    await this.storage.set('email', data.work_email);
    await this.storage.set('first_name', data.first_name);
    await this.storage.set('last_name', data.last_name);
    await this.storage.set('free_trial_mode', data.free_trial_mode == 1 ? true : false);
    await this.storage.set('job_title', data.job_title);
  };

  private  stripSpacesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const value = control.value
        const strippedValue = value.replace(/\D+/g,''); 
        const limitedValue = strippedValue.slice(0, 10);
        if (limitedValue !== control.value) {
          control.setValue(limitedValue, { emitEvent: false });
        }
      }
      return null;
    };
  }

  ngOnDestroy() {
    this.countriesApi.unsubscribe();
    if (this.submitdone) {
      this.registerApi.unsubscribe();
    }
    this._destroying$.next(undefined);
    this._destroying$.complete();
    // this.helperService.closeLoader();
  }

}
